import { EmbedViewModel } from "../interfaces/Paineis";
import { TvPlaylistResposta } from "../interfaces/PaineisTvTema";

/**
 * Cliente da TV pública. `fetch` próprio: a TV não tem JWT, então não passa pelo interceptor
 * (e renovar sessão aqui não faz sentido). A chave vai no header `X-Tv-Key`, nunca na URL.
 */

/** 401 = chave inválida/revogada ou playlist inativa ("TV desativada"). */
export class TvError extends Error {
  status: number;

  constructor(status: number, message: string) {
    super(message);
    this.name = "TvError";
    this.status = status;
  }
}

const base = (process.env.REACT_APP_URL_API_NINA ?? "").replace(/\/+$/, "");

async function tvGet<T>(chave: string, caminho: string): Promise<T> {
  const resp = await fetch(`${base}/bi/tv/${caminho}`, { headers: { "X-Tv-Key": chave } });
  if (!resp.ok) {
    let message = "Falha ao consultar a TV.";
    try {
      message = (await resp.json())?.message ?? message;
    } catch {
      /* corpo vazio ou não-JSON: fica a mensagem padrão */
    }
    throw new TvError(resp.status, message);
  }
  return resp.json();
}

export const getTvPlaylist = (chave: string): Promise<TvPlaylistResposta> => tvGet(chave, "playlist");

/** 404 = relatório despublicado/indisponível; 503 = conexão indisponível. */
export const getTvEmbed = (chave: string, indice: number): Promise<EmbedViewModel> =>
  tvGet(chave, `itens/${indice}/embed`);
